export default __webpack_public_path__ + "static/media/sloution-box-lft-img.d5735d66.png";